import colors from '../tokens/colors';

export const autocompleteGetolo = {
  group: {
    border: `1px solid`,
    borderColor: colors.PROFESSIONAL_BLUE,
  },
  noOption: {
    mainMessageColor: colors.PROFESSIONAL_LIGHT_BLUE,
    extraMessageColor: colors.PROFESSIONAL_BLUE,
  },
};

export const autocompleteDaDirekt = {
  group: {
    border: '1px solid',
    borderColor: `${colors.PROFESSIONAL_BLUE}`,
  },
  noOption: {
    mainMessageColor: colors.PRODUCT_BLUE,
    extraMessageColor: colors.PROFESSIONAL_BLUE,
  },
};

export const autocompleteDaKaufland = {
  group: {
    border: '1px solid',
    borderColor: `${colors.DA_KAUFLAND_BLACK}`,
  },
  noOption: {
    mainMessageColor: colors.DA_KAUFLAND_GRAY_1,
    extraMessageColor: colors.DA_KAUFLAND_BLACK,
  },
};

export const autocompleteDaFressnapf = {
  group: {
    border: '1px solid',
    borderColor: `${colors.FRESSNAPF_TEXT_PLACEHOLDER}`,
  },
  noOption: {
    mainMessageColor: colors.FRESSNAPF_TEXT_PLACEHOLDER,
    extraMessageColor: colors.FRESSNAPF_TEXT_PRIMARY,
  },
};
